"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var React = __importStar(require("react"));
var styledLayout_1 = require("../base/styledLayout");
var text_1 = require("../base/text");
var inputWrapper_1 = require("../inputWrapper");
var form_1 = require("../form");
var check_1 = require("../icons/check");
exports.Checkbox = React.memo(function (_a) {
    var name = _a.name, type = _a.type, message = _a.message, text = _a.text, onChange = _a.onChange, onlyChildren = _a.onlyChildren, controlledValue = _a.controlledValue, _b = _a.passive, passive = _b === void 0 ? false : _b, _c = _a.label, label = _c === void 0 ? '' : _c, _d = _a.defaultValue, defaultValue = _d === void 0 ? false : _d;
    var _e = form_1.useForm(defaultValue, name, type, message), input = _e[0], setInput = _e[1], _type = _e[2], _message = _e[3];
    var checkboxWrapperClassName = classnames_1.default('ty-checkbox-wrapper', { 'ty-checkbox-active': input, 'ty-checkbox-passive': passive });
    var checkboxClassName = classnames_1.default('ty-input', 'ty-checkbox', 'ty-bordered');
    var _onChange = React.useCallback(function () {
        var value = !input;
        setInput(value);
        if (typeof onChange === 'function') {
            onChange(value);
        }
    }, [input]);
    React.useMemo(function () {
        setInput(controlledValue || false);
    }, [controlledValue]);
    return (React.createElement(inputWrapper_1.InputWrapper, { passive: passive, type: _type, message: _message, label: label, onlyChildren: onlyChildren },
        React.createElement(styledLayout_1.StyledLayout, { display: "ty-display-flex" /* Flex */, className: checkboxWrapperClassName, onClick: !passive && _onChange },
            React.createElement(styledLayout_1.StyledLayout, { position: "ty-relative" /* Relative */, className: "ty-checkbox-container", margin: "ty-mgr-2" /* Two */ },
                React.createElement(styledLayout_1.StyledLayout, { 
                    // style props
                    backgroundColor: "ty-bg-beige" /* Beige */, margin: "ty-mg-zero" /* Zero */, 
                    // input props
                    disabled: passive, value: input, name: name, 
                    // custom props
                    className: checkboxClassName }),
                React.createElement(check_1.Check, null)),
            React.createElement(text_1.Text, { className: "ty-checkbox-text", fontSize: "ty-font-md" /* Medium */, color: "ty-color-soft-gray" /* SoftGray */ }, text))));
});
